// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { ToastContainer } from 'react-toastify';

const ToastHost = () => (
  <ToastContainer
    position="top-right"
    hideProgressBar
    newestOnTop
    autoClose={4000}
    closeButton={false}
    draggable={false}
    pauseOnHover
    pauseOnFocusLoss={false}
    className="wurqly-toast-container"
    toastClassName="wurqly-toast"
    bodyClassName="wurqly-toast__body"
    style={{ zIndex: 9999999 }}
  />
);

export default ToastHost;
